<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{ $t('basicData.annex') }}</span>
    </div>

    <UploadCmp
      ref="uploadRef"
      :drag="false"
      :multiple="false"
      :auto-upload="true"
      :limit="10"
      :file-size="10"
      :tips="tips"
      :show-file-list="false"
      :file-type="['image/png', 'image/jpeg', 'image/bmp', 'application/pdf']"
      :is-check-file-type="true"
      :upload-text="$t('spareNumberPoo.SelectTheFile')"
      @change="onFileChange"
    />
    <div class="file-list">
      <ul class="el-upload-list el-upload-list--text">
        <li v-for="(item, index) in fileData" :key="index" class="el-upload-list__item feet-r">
          <el-link target="_blank" :href="item.url">
            <i class="el-icon-document" />
            {{ item.name }}
          </el-link>
          <div>
            <span class="el-icon-download addStyle" @click="downloadFile(item, index)" />
            <span class="el-icon-delete deleteStyle" @click="handleRemove(item, index)" />
          </div>
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import i18n from '@/lang';
import { debounce } from 'lodash-es';

export default {
  name: 'ImportFile',
  components: {
    UploadCmp: () => import('@/views/claimsManagement/claimStatement/cmp/UploadCmp.vue')
  },
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tips: i18n.t('basicData.fileUpload'),
      fileData: [] // 文件列表
    };
  },

  watch: {
    fileList: {
      handler(val) {
        if (!val) {
          return;
        }
        this.fileData = val;
      },
      immediate: true
    }
  },
  methods: {
    onFileChange(arr) {
      console.log(arr, '上传文件list');
      // 去重
      const ids = this.fileData.map(item => item.uid);
      for (let i = 0; i < arr.length; i++) {
        const items = arr[i];
        if (!ids.includes(items.uid)) {
          this.fileData.push(items);
        }
      }
      console.log(this.fileData, 'this.fileData');
      // this.fileData = [
      //   ...this.fileData,
      //   ...arr
      // ];
    },

    // 下载
    downloadFile: debounce(async function(item, index) {
      const url = item.url;
      const fileName = url.split('/').pop().split('?')[0];
      try {
        const response = await fetch(url);
        if (!response.ok) {
          this.$message.error(`Network response was not ok: ${response.statusText}`);
          this.loading = false;
          return;
        }

        const blob = await response.blob();

        // 下载逻辑
        const triggerDownload = (dataBlob) => {
          const downloadElement = document.createElement('a');
          const objectURL = window.URL.createObjectURL(dataBlob);

          downloadElement.href = objectURL;
          downloadElement.download = fileName || '';
          document.body.appendChild(downloadElement);
          downloadElement.click();

          // 清理资源
          setTimeout(() => {
            window.URL.revokeObjectURL(objectURL);
            document.body.removeChild(downloadElement);
          }, 0);
        };

        triggerDownload(blob); // 触发下载
      } catch (error) {
        console.log('解析失败:', error);
        this.$message.error('文件链接失效！');
      }
    }, 500),

    // 删除
    handleRemove(item, index) {
      console.log(item, index);
      this.fileData.splice(index, 1);
    },

    // 获取文件列表
    getFiles() {
      return this.fileData;
    },

    // 清空列表
    clearFiles() {
      this.fileData = [];
      this.$refs.uploadRef.clearFiles();
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-upload {
  text-align: left !important;
}
.deleteStyle, .addStyle {
  font-size: 14px;
  padding: 0 10px;
}
</style>
